<template>
    <div class="button-container">
        <div class="button-panel">
            <ms-store-button></ms-store-button>
        </div>
    </div>
</template>

<script setup lang="ts">
import MsStoreButton from "@/components/download/MsStoreButton.vue";
</script>

<style scoped>
.button-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.button-panel {
    display: flex;
    flex-direction: row;
    align-items: center;
}
</style>
